const LOCAL_KEY = "herra.auth.local";
const SESSION_KEY = "herra.auth.session";

const readStorage = (storage, key) => {
  const raw = storage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    storage.removeItem(key);
    return null;
  }
};

const writeStorage = (storage, key, value) => {
  storage.setItem(key, JSON.stringify(value));
};

export const tokenStorage = {
  saveSession(session, remember) {
    if (remember) {
      writeStorage(localStorage, LOCAL_KEY, { ...session, remember: true });
      sessionStorage.removeItem(SESSION_KEY);
    } else {
      writeStorage(sessionStorage, SESSION_KEY, { ...session, remember: false });
      localStorage.removeItem(LOCAL_KEY);
    }
  },

  getSession() {
    return readStorage(localStorage, LOCAL_KEY) || readStorage(sessionStorage, SESSION_KEY);
  },

  clear() {
    localStorage.removeItem(LOCAL_KEY);
    sessionStorage.removeItem(SESSION_KEY);
  },
};
